import React, {Component} from 'react';


const FooterItem = ({ href, text}) => (
	<a href={href}>
		<div className="gcAd-footer-item">
			{text}
		</div>
	</a>
)

class Footer extends Component{
    render(){
        const {FooterLinks} = this.props;

        return (
            <section id="sgFooter" className="gcAd-section game-footer" data-section="7">
                <div className="gcAd-footer-list">
                    {FooterLinks.map(link =>
                        <FooterItem
                            key={Object.keys(FooterLinks)[FooterLinks.indexOf(link)]}
                            href={link.href}
                            text={link.text}
                        />
                    )}
                </div>
            </section>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer.js